import db from "../db/database";
import { markForDelete, markForSync } from "./syncService";

// Servicio para manejar las operaciones relacionadas con los colegios

// Agregar un nuevo colegio a la base de datos
export const addColegio = async (colegio) => {
    try {
        // Verificar si el nombre del colegio ya existe
        const existingColegio = await db.colegios
            .where("nombre")
            .equals(colegio.nombre)
            .first();

        if (existingColegio) {
            throw new Error("Ya existe un colegio con ese nombre");
        }

        // Agregar el colegio a la base de datos
        const id = await db.colegios.add({
            nombre: colegio.nombre,
            createdAt: new Date(),
            pendingSync: 1, // Marcar como pendiente de sincronización (usando 1 en lugar de true)
            lastModified: new Date(),
            No: colegio.No || null, // Guardar el No de Business Central si existe
            deleted: false,
        });

        return { id, ...colegio };
    } catch (error) {
        console.error("Error al agregar colegio:", error);
        throw error;
    }
};

// Obtener todos los colegios
export const getAllColegios = async () => {
    try {
        // Obtener solo colegios no marcados como eliminados
        const colegios = await db.colegios
            .filter((colegio) => !colegio.deleted)
            .toArray();
        return colegios;
    } catch (error) {
        console.error("Error al obtener colegios:", error);
        throw error;
    }
};

// Obtener un colegio por ID local
export const getColegioById = async (id) => {
    try {
        const colegio = await db.colegios.get(id);
        if (!colegio || colegio.deleted) {
            throw new Error("Colegio no encontrado");
        }
        return colegio;
    } catch (error) {
        console.error(`Error al obtener colegio con ID ${id}:`, error);
        throw error;
    }
};

// Obtener un colegio por No de Business Central
export const getColegioByNo = async (no) => {
    try {
        const colegio = await db.colegios
            .where("No")
            .equals(no)
            .and((colegio) => !colegio.deleted)
            .first();

        if (!colegio) {
            throw new Error("Colegio no encontrado");
        }
        return colegio;
    } catch (error) {
        console.error(`Error al obtener colegio con No ${no}:`, error);
        throw error;
    }
};

// Actualizar un colegio existente
export const updateColegio = async (id, colegioData) => {
    try {
        const colegio = await db.colegios.get(id);
        if (!colegio || colegio.deleted) {
            throw new Error("Colegio no encontrado");
        }

        // Actualizar el colegio
        await db.colegios.update(id, {
            ...colegioData,
            lastModified: new Date(),
        });

        // Marcar como pendiente de sincronización
        await markForSync("colegios", id);

        return await getColegioById(id);
    } catch (error) {
        console.error(`Error al actualizar colegio con ID ${id}:`, error);
        throw error;
    }
};

// Eliminar un colegio
export const deleteColegio = async (id) => {
    try {
        const colegio = await db.colegios.get(id);
        if (!colegio) {
            throw new Error("Colegio no encontrado");
        }

        // Marcar como eliminado y pendiente de sincronización
        await markForDelete("colegios", id);

        return true;
    } catch (error) {
        console.error(`Error al eliminar colegio con ID ${id}:`, error);
        throw error;
    }
}; 